import React from 'react';
import logo from '../Media/LogoLogin.png';
import { Link } from "react-router-dom";
import '../global/GlobalCSS.css';

const Logo = () => {
    return (
        <>
            <div className="d-flex">
                <div className="navbar-brand-box" style={{ minHeight: '3rem', minWidth: '5rem' }}>
                    <Link to="/dashboard" className="logo logo-dark pos-start-0_75">
                        <span className="logo-sm">
                            <img src={logo} alt="" height="" />
                        </span>
                        <span className="logo-lg">
                            <img src={logo} alt="" height="80" />
                        </span>
                    </Link>

                    <Link to="/dashboard" className="logo logo-light">
                        <span className="logo-sm">
                            <img src={logo} alt="" height="24" />
                        </span>
                        <span className="logo-lg">
                            <img src={logo} alt="" height="24" />
                            <span className="logo-txt">ecoSAIL</span>
                        </span>
                    </Link>
                </div>
            </div>
        </>
    )
}

export default Logo;